var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { attrs: { "data-test": "reservation-" + _vm.reservation.id } },
    [
      _c(
        "td",
        { staticClass: "boss-table-data" },
        [
          _c("span", { attrs: { "data-test": "reservation-name" } }, [
            _vm._v(_vm._s(_vm.reservation.name)),
          ]),
          _vm._v(" "),
          _vm.isReserved
            ? [
                _vm.reservation.includeFirstSendUser
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "boss-status-label pega-status-label position-static",
                        attrs: { "data-test": "reservation-first-send" },
                      },
                      [_vm._v("初送\n      ")]
                    )
                  : _c(
                      "span",
                      {
                        staticClass:
                          "boss-status-label pega-status-label position-static pega-status-label-black",
                        attrs: { "data-test": "reservation-resent" },
                      },
                      [_vm._v("再送\n      ")]
                    ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "boss-table-data",
          attrs: { "data-test": "reservation-subject" },
        },
        [_vm._v("\n    " + _vm._s(_vm.reservation.subject) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "boss-table-data" },
        _vm._l(_vm.reservation.specialFavors, function (favor, i) {
          return _c(
            "span",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: { content: _vm.specialFavorBy(favor.id).description },
                  expression:
                    "{ content: specialFavorBy(favor.id).description}",
                },
              ],
              key: i,
              staticClass: "boss-bonus-check-text boss-check-true",
              attrs: {
                "data-test":
                  "special-favor-" + _vm.reservation.id + "-" + favor.id,
              },
            },
            [_vm._v(_vm._s(favor.name))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "boss-table-data",
          attrs: { "data-test": "reservation-send-date" },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm._f("parseDateFormat")(_vm.reservation.sendDate)) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "boss-table-data",
          attrs: { "data-test": "reservation-status" },
        },
        [
          _c("span", [
            _vm._v("\n      " + _vm._s(_vm.reservation.status.name) + "\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "boss-table-data" }, [
        !_vm.isReserved
          ? _c("span", { attrs: { "data-test": "reservation-count" } }, [
              _vm._v(_vm._s(_vm.reservation.count + "通/")),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          { attrs: { "data-test": "reservation-expectation-count" } },
          [_vm._v(_vm._s(_vm.reservation.expectationCount))]
        ),
        _vm._v("通\n  "),
      ]),
      _vm._v(" "),
      _vm.showEdit
        ? [
            _c("td", { staticClass: "boss-table-data" }, [
              _vm.isEdit
                ? _c("button", {
                    staticClass: "boss-icon-pencil",
                    attrs: { "data-test": "reservation-edit" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({
                          name: "scoutCreateReservation",
                          params: {
                            idAndNameObjects: _vm.reservation.targetUsers,
                            jobId: _vm.jobId,
                            contractId: _vm.contractId,
                            reservationId: _vm.reservation.id,
                          },
                        })
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "boss-table-data" }, [
              _vm.isEdit
                ? _c("button", {
                    staticClass: "boss-icon-trash",
                    attrs: { "data-test": "reservation-remove" },
                    on: {
                      click: function ($event) {
                        return _vm.doRemove(_vm.reservation.id)
                      },
                    },
                  })
                : _vm._e(),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }